import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

interface UserState {
  isLoggedIn: boolean;
  userInfo: any;
  clientInfo: any;
}

// 从localStorage恢复用户信息的辅助函数
const restoreUserInfo = () => {
  try {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const userInfoStr = localStorage.getItem('userInfo');
    const clientInfoStr = localStorage.getItem('clientInfo');
    const accessToken = localStorage.getItem('access_token');
    const userId = localStorage.getItem('user_id');
    
    // 验证token是否存在
    if (!accessToken) {
      return {
        isLoggedIn: false,
        userInfo: null,
        clientInfo: null
      };
    }
    
    // 解析用户信息
    let userInfo = null;
    if (userInfoStr) {
      try {
        userInfo = JSON.parse(userInfoStr);
        // 确保userInfo包含必要的token信息
        if (!userInfo.access_token) {
          userInfo.access_token = accessToken;
        }
        if (!userInfo.user_id && userId) {
          userInfo.user_id = userId;
        }
      } catch (e) {
        console.error('解析userInfo失败:', e);
        userInfo = null;
      }
    }
    
    // 解析client信息
    let clientInfo = null;
    if (clientInfoStr) {
      try {
        clientInfo = JSON.parse(clientInfoStr);
      } catch (e) {
        console.error('解析clientInfo失败:', e);
        clientInfo = null;
      }
    }
    
    return {
      isLoggedIn: isLoggedIn && !!userInfo,
      userInfo: userInfo,
      clientInfo: clientInfo
    };
  } catch (error) {
    console.error('恢复用户信息失败:', error);
    return {
      isLoggedIn: false,
      userInfo: null,
      clientInfo: null
    };
  }
};

const restoredData = restoreUserInfo();

const store = new Vuex.Store({
  state: {
    systemInfo: {},
    // 用户状态 - 从localStorage恢复
    isLoggedIn: restoredData.isLoggedIn,
    userInfo: restoredData.userInfo,
    clientInfo: restoredData.clientInfo,
  },

  mutations: {
    updateSystemInfo(state, data) {
      state.systemInfo = data;
    },
    // 用户相关 mutations
    setUserInfo(state, userInfo: any) {
      console.log("setUserInfo", userInfo);
      state.userInfo = userInfo;
      state.isLoggedIn = true;
      
      // 保存到localStorage
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      
      // 处理token
      if (userInfo && userInfo.access_token) {
        const token = typeof userInfo.access_token === 'object'
          ? userInfo.access_token.access_token
          : userInfo.access_token;
        if (token) {
          localStorage.setItem('access_token', token);
        }
      }
      
      // 处理user_id
      if (userInfo && userInfo.user_id) {
        localStorage.setItem('user_id', userInfo.user_id);
      } else if (userInfo && userInfo.user) {
        localStorage.setItem('user_id', userInfo.user);
      }
    },
    setClientInfo(state, clientInfo: any) {
      state.clientInfo = clientInfo;
      localStorage.setItem('clientInfo', JSON.stringify(clientInfo));
    },
    clearUserInfo(state) {
      state.userInfo = null;
      state.isLoggedIn = false;
      state.clientInfo = null;
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('clientInfo');
    },
    // 恢复用户信息
    restoreUserInfo(state) {
      const restoredData = restoreUserInfo();
      state.isLoggedIn = restoredData.isLoggedIn;
      state.userInfo = restoredData.userInfo;
      state.clientInfo = restoredData.clientInfo;
    }
  },

  actions: {
    logout({ commit }) {
      commit('clearUserInfo');
    },
    // 初始化时恢复用户信息
    initUserInfo({ commit }) {
      commit('restoreUserInfo');
    }
  },

  getters: {
    // 用户相关 getters
    isLoggedIn: state => state.isLoggedIn,
    userInfo: state => state.userInfo,
    clientInfo: state => state.clientInfo,
    // 获取token的getter
    accessToken: state => {
      if (state.userInfo && state.userInfo.access_token) {
        return typeof state.userInfo.access_token === 'object'
          ? state.userInfo.access_token.access_token
          : state.userInfo.access_token;
      }
      return localStorage.getItem('access_token');
    }
  }
});

export default store;
